import React from 'react'
import ReactDOM from 'react-dom'
import { ChakraProvider, theme, CSSReset } from '@chakra-ui/react'
import { Global, css } from '@emotion/react'
import { Helmet } from 'react-helmet'
import 'react-dates/initialize'
import { ApolloProvider } from '@apollo/react-hooks'
import client from './apollo'
import App from './App'
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import { APP_NAME } from './constants'
import { AppProvider, AuthProvider } from './context'

import './i18next'

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <ChakraProvider theme={theme}>
        <AuthProvider>
          <Helmet titleTemplate={`${APP_NAME} - %s`} />
          <AppProvider>
            <CSSReset />
            <Global
              styles={css`
                :root {
                  --chakra-fontSizes-lg: '18px';
                  --primary-500: ${theme.colors.blue[500]};
                  --secondary-400: ${theme.colors.purple[500]};
                  --foreground-rgb: 0, 0, 0;
                  --background-start-rgb: 214, 219, 220;
                  --background-end-rgb: 255, 255, 255;

                  --primary-glow: conic-gradient(
                    from 180deg at 50% 50%,
                    #16abff33 0deg,
                    #0885ff33 55deg,
                    #54d6ff33 120deg,
                    #0071ff33 160deg,
                    transparent 360deg
                  );
                  --secondary-glow: radial-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
                }
                *:focus {
                  box-shadow: none !important;
                }
                .withGlow {
                  position: relative;
                }
                p,
                h1,
                h2,
                h3,
                h4,
                h5,
                h6 {
                  font-family: Circular, -apple-system, 'system-ui', Roboto, 'Helvetica Neue',
                    sans-serif;
                }

                .withGlow::before {
                  background: var(--secondary-glow);
                  border-radius: 50%;
                }

                .withGlow::after {
                  background: var(--primary-glow);
                  margin-top: 50px;
                  width: 240px;
                  height: 380px;
                  margin-left: -200px;
                  z-index: -1;
                }

                .withGlow::before,
                .withGlow::after {
                  content: '';
                  left: 50%;
                  position: absolute;
                  filter: blur(45px);
                  transform: translateZ(0);
                }
                * {
                  font-family: ${theme.fonts.body};
                  box-sizing: border-box;
                }
                body {
                  overflow-x: hidden;
                }
              `}
            />
            <App />
          </AppProvider>
        </AuthProvider>
      </ChakraProvider>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
